const types = {
  GET_PROVIDER_BY_NAME: '@@PO_searches/GET_PROVIDER_BY_NAME',
};

export default types;
